import { html, nothing, TemplateResult } from 'lit-html';
import CloseButtonTemplate from '@libs/modal/closeButton';
import { ErrorModalTemplate, WelcomeModalTemplate } from '@components/commonTemplate';
import FormTemplate from './form';

const Template = async (config: ProposalConfigs, model: IProposalModel): Promise<TemplateResult> => {
  const {
    messages,
  } = config;
  const {
    close,
    modalState,
  } = model;
  const LINK_TO_GMAIL = 'https://mail.google.com/mail/u/0/';

  const welcomeTemplateProps: IWelcomeModalTemplateProps = {
    messages,
    linkToInboxProviderUrl: LINK_TO_GMAIL,
    close,
    source: 'google_one_tap'
  }

  return html`
    <div class="go-to-mail ${modalState === 'proposal' ? 'proposal' : ''}">      
      ${CloseButtonTemplate(close)}
      ${modalState === 'error' ? ErrorModalTemplate({ messages, close }) : nothing}
      ${modalState === 'proposal' ? await FormTemplate(config, model) : nothing}
      ${modalState === 'welcome' ? WelcomeModalTemplate(welcomeTemplateProps) : nothing}
    </div>`;
}

export default Template;
